import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { PostSortiereAbschnitteCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [PostSortiereAbschnitteCommandService],
  exports: []
})
export class PostSortiereAbschnitteCommandServiceModule { }
